import { Action } from '@ngrx/store';

import { INoteDto,CatNoteDto } from '@shared/service-proxies/service-proxies';

export const LOAD_NOTES = '[Notes] Load notes';
export const LOAD_NOTES_SUCCEEDED = '[Notes] Load notes succeeded';
export const ADD_NOTE = '[Notes] Add note';
export const ADD_NOTE_SUCCEEDED = '[Notes] Add note succeeded';
export const RESET = '[Notes] Reset';

export class LoadNotesAction implements Action {
    readonly type = LOAD_NOTES;

    constructor(public notebookId: string, public noteType: string) { }
}

export class LoadNotesSucceededAction implements Action {
    readonly type = LOAD_NOTES_SUCCEEDED;

    constructor(public notes: CatNoteDto[]) { }
}

export class AddNoteAction implements Action {
    readonly type = ADD_NOTE;

    constructor(public notebookId: string, public noteType: string, public message: string) { }
}

export class AddNoteSucceededAction implements Action {
    readonly type = ADD_NOTE_SUCCEEDED;

    constructor(public note: INoteDto) { }
}

export class ResetAction implements Action {
    readonly type = RESET;

    constructor() { }
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Actions =
    LoadNotesAction
    | LoadNotesSucceededAction
    | AddNoteAction
    | AddNoteSucceededAction
    | ResetAction;
